import { LuChartColumn } from 'react-icons/lu';

/**
 * 分析画面のデータなし状態コンポーネント
 * Figma: 2886:17459
 */
export default function AnalysisNoData() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <div className="mb-4 flex size-16 items-center justify-center rounded-full bg-gray-100">
        <LuChartColumn className="size-8 text-gray-400" />
      </div>
      <p className="text-base font-medium text-gray-600">データがありません</p>
      <p className="mt-1 text-sm text-gray-400">期間やフィルター条件を変更してお試しください</p>
    </div>
  );
}
